import { render, staticRenderFns } from "./ManualBlock.vue?vue&type=template&id=432d17a2&scoped=true&"
import script from "./ManualBlock.vue?vue&type=script&lang=ts&"
export * from "./ManualBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ManualBlock.vue?vue&type=style&index=0&id=432d17a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d17a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VChip,VFlex,VImg})
